<template>
    <div
        :class="classes"
        class="inline-flex items-center inline-block w-6 h-6 text-white border rounded focus:outline-none"
        role="checkbox"
        tabindex="0"
        @click.prevent="toggle"
        @keydown.space.prevent="toggle"
    >
        <base-svg
            v-show="checked"
            name="icon-check"
            class="w-6 h-6 mx-auto fill-primary-white"
        />

        <input
            :checked="checked"
            :value="value"
            type="checkbox"
            class="hidden"
        >
    </div>
</template>

<script>
    import _ from 'lodash'

    export default {
        model: {
            prop: 'isChecked',
            event: 'toggle'
        },
        props: {
            isChecked: {
                type: [Array, Boolean],
                required: true
            },
            value: {
                type: String,
                default: null
            },
            validatorName: {
                type: String,
                default: null
            },
            sid: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            isInteractive: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            checked () {
                return this.value
                    ? _.includes(this.isChecked, this.value)
                    : this.isChecked
            },
            classes () {
                const classes = [
                    'shadow-inner'
                ]

                if (this.$validator.has(this.validatorName, this.sid)) {
                    classes.push([
                        'border-red',
                        'hover:border-red-darker'
                    ])
                } else {
                    if (this.disabled || !this.isInteractive) {
                        classes.push([
                            'cursor-not-allowed',
                            'bg-grey-lightest'
                        ])
                    } else {
                        classes.push([
                            'cursor-pointer',
                            'focus:shadow-outline'
                        ])
                    }

                    if (this.isChecked) {
                        classes.push([
                            'border-blue!',
                            'bg-blue!'
                        ])
                    }
                }

                return classes
            }
        },
        methods: {
            toggle () {
                if (this.disabled) return

                if (this.isInteractive) {
                    const value = this.value
                        ? _.includes(this.isChecked, this.value)
                            ? _.without(this.isChecked, this.value)
                            : _.concat(this.isChecked, this.value)
                        : !this.isChecked

                    this.$emit('toggle', value)
                    this.$emit('input', value)
                }
            }
        }
    }
</script>
